import window from '../globalWrappers/window.js';

function browserIsIE() {
  let agent = window.navigator.userAgent;

  return agent.includes('MSIE') || agent.includes('Trident/');
}

export default browserIsIE;
